// utils/cursor.ts
import { useEffect } from "react";

export function useCursorWhileAny(
  conditions: boolean[],
  cursorStyle: string = "wait"
) {
  useEffect(() => {
    const anyTrue = conditions.some(Boolean);
    document.body.style.cursor = anyTrue ? cursorStyle : "default";

    return () => {
      // Reset on unmount
      document.body.style.cursor = "default";
    };
  }, [conditions, cursorStyle]);
}